import React, {FC} from 'react'
import Select from 'react-select'
import {gql} from '@apollo/client'
import {useController, useFormContext} from 'react-hook-form'
import {useQuery} from 'hooks/graphql'
import {Body, BodyItems, Header, Row} from 'components/SearchForm/AdditionalSearchField'
import {Option, toOpts, withNullOpt} from 'libs/options'
import styles from './Tags.scss'

const TAGS = gql`
  query tags {
    client {
      employeeConnections {
        tags {
          id
          name
        }
      }
    }
  }
`

interface TagsQueryResult {
  client: {
    employeeConnections: {
      tags: {
        id: string
        name: string
      }[]
    }
  }
}

export const Tags: FC = () => {
  const {data} = useQuery<TagsQueryResult>(TAGS, {fetchPolicy: 'cache-and-network'})
  const tags = data?.client?.employeeConnections?.tags || []

  return (
    <Row>
      <Header>タグ</Header>
      <Body>
        <BodyItems>
          <div className={styles.box}>
            <TagSelect name="tags" options={withNullOpt(toOpts(tags))} />
          </div>
        </BodyItems>
      </Body>
    </Row>
  )
}

interface TagSelectProps {
  name: string
  options: Option[]
}

const TagSelect: FC<TagSelectProps> = ({name, options}) => {
  const {control} = useFormContext()
  const {field} = useController({control, name, shouldUnregister: true})

  return (
    <Select
      multi
      options={options}
      closeOnSelect={false}
      placeholder="タグ選択"
      value={field.value}
      noResultsText="データが見つかりません"
      onChange={(value) => {
        if (!Array.isArray(value)) {
          return
        }
        const values = value.map((v) => v.value).filter((v) => v !== undefined)
        field.onChange(values)
        field.onBlur()
      }}
    />
  )
}
